import * as DTO from './DTOs';
import * as Session from './Session';
import { ReactElement } from 'react';



export class AppConfig {
    static locale = {
        thousand_delimiter: " ",
        numeralDecimalMark: ','
    };
}

export interface AppState {
    connection: DTO.HubConnection;
    syshdr: DTO.SystemHeader;
    sysavail: DTO.SystemOperationAvailabilityDto;
    dsctx: DTO.AgentDSContext;
    //online?: boolean;
    user?: Session.UserState;
    alerts: DTO.AlertMessage[];
    uiContext: DTO.UserInteractionContext;
    tmessages: DTO.AgentTextMessage[];
    chatactivity: DTO.AgentChatActivity[];
    appId: number;
    appFamily: string;
    sharedChatId?: number;
    marketquotes?: DTO.MarketQuotes;
}

const _appState: AppState = {
    connection: { status: 'disconnected' },
    sysavail: {
        //tradesession: { isopen: false, suspended: false, readonly: false },
        instruments: [
            { fiid: "1", perms: [], readonly: false, suspended: false, tradeopen: false },
            { fiid: "2", perms: [], readonly: false, suspended: false, tradeopen: false },
            { fiid: "3", perms: [], readonly: false, suspended: false, tradeopen: false },
            { fiid: "4", perms: [], readonly: false, suspended: false, tradeopen: false },
            { fiid: "5", perms: [], readonly: false, suspended: false, tradeopen: false },
            { fiid: "6", perms: [], readonly: false, suspended: false, tradeopen: false }
        ]
    },
    dsctx: {
        instrumentsDS: {
            instruments: [
                { fiid: "1", isContragentLimits: false, isSecuritiesFilters: false },
                { fiid: "2", isContragentLimits: false, isSecuritiesFilters: false },
                { fiid: "3", isContragentLimits: false, isSecuritiesFilters: false },
                { fiid: "4", isContragentLimits: false, isSecuritiesFilters: false },
                { fiid: "5", isContragentLimits: false, isSecuritiesFilters: false },
                { fiid: "6", isContragentLimits: false, isSecuritiesFilters: false },
            ]
        },
        myDealsDS: {
            periodFilter: { isCurrentPeriod: false, startDateIncl: new Date('2018-09-01') },
            attributesFilter: { isMyOwnOnly: false }
        },
        myOrdersDS: {
            periodFilter: { isCurrentPeriod: true },
            attributesFilter: { isMyOwnOnly: false }
        }
    },
    syshdr: { sstamp: '', hasfreshchanges: false },
    alerts: [],
    uiContext: {},
    tmessages: [],
    chatactivity: [],
    appId: 0,
    appFamily: "Trading"
};

export default _appState;

export function routeServerAction(action: string | undefined): string | undefined {
    if (action == 'changepassword')
        return '/chpassword';
    else if (action == 'refresh') {
        window.location.reload(true);
    }
    else
        return undefined;
}


export interface BrowserCompatibility {
    compatibility: boolean,
    browser: string
};

export function browserCompat(): BrowserCompatibility {
    let ret = { compatibility: false, browser: 'Unknown' };

    let browser = BrowserDetection();
    ret.browser = browser;
    ret.compatibility = (browser == 'Chrome' || browser == 'Firefox' || browser == 'Safari' || browser == 'Opera') || browser == 'Edge';

    return ret;
}


export function BrowserDetection() {
    let ver = detectIE();

    //if (navigator.userAgent.search("MSIE") >= 0) {
    //    return "IE";
    //}
    //else

    if (ver == 0) {
        if (navigator.userAgent.search("Chrome") >= 0) {
            return "Chrome";
        }
        else if (navigator.userAgent.search("Firefox") >= 0) {
            return "Firefox";
        }
        else if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
            return "Safari";
        }
        else if (navigator.userAgent.search("Opera") >= 0) {
            return "Opera";
        }
    }
    else {
        if (ver <= 11)
            return "IE";
        else if (ver >= 12)
            return "Edge";
        else
            return "Unknown"
    }
    return "Unknown";
}

function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return 0;
}





//import * as DTO from './DTOs';
//import * as Session from './Session';
//import { ReactElement } from 'react';




//export interface AppState {
//    connection: DTO.HubConnection;
//    syshdr: DTO.SystemHeader;
//    sysavail: DTO.SystemOperationAvailabilityDto;
//    dsctx: DTO.AgentDSContext;
//    //online?: boolean;
//    user?: Session.UserState;
//    alerts: DTO.AlertMessage[];
//    uiContext: DTO.UserInteractionContext;
//    tmessages: DTO.AgentTextMessage[];
//}

//const _appState: AppState = {
//    connection: { status: 'disconnected' },
//    sysavail: {
//        //tradesession: { isopen: false, suspended: false, readonly: false },
//        instruments: [
//            { fiid: "1", perms: [], readonly: false, suspended: false, tradeopen: false },
//            { fiid: "2", perms: [], readonly: false, suspended: false, tradeopen: false },
//            { fiid: "3", perms: [], readonly: false, suspended: false, tradeopen: false },
//            { fiid: "4", perms: [], readonly: false, suspended: false, tradeopen: false },
//            { fiid: "5", perms: [], readonly: false, suspended: false, tradeopen: false },
//            { fiid: "6", perms: [], readonly: false, suspended: false, tradeopen: false }
//        ]
//    },
//    dsctx: {
//        instrumentsDS: {
//            instruments: [
//                { fiid: "1", isContragentLimits: false, isSecuritiesFilters: false },
//                { fiid: "2", isContragentLimits: false, isSecuritiesFilters: false },
//                { fiid: "3", isContragentLimits: false, isSecuritiesFilters: false },
//                { fiid: "4", isContragentLimits: false, isSecuritiesFilters: false },
//                { fiid: "5", isContragentLimits: false, isSecuritiesFilters: false },
//                { fiid: "6", isContragentLimits: false, isSecuritiesFilters: false },
//                ]
//        },
//        myDealsDS: {
//            periodFilter: { isCurrentPeriod: true }
//        },
//        myOrdersDS: {
//            periodFilter: {
//                isCurrentPeriod: true
//            } }
//    },
//    syshdr: { sstamp: '', hasfreshchanges: false },
//    alerts: [],
//    uiContext: {},
//    tmessages: []
//};

//export default _appState;

//export function routeServerAction(action: string | undefined ): string | undefined {
//    if (action == 'changepassword')
//        return '/chpassword';
//    else
//        return undefined;
//}


//export interface BrowserCompatibility
//{
//    compatibility: boolean,
//    browser: string
//};

//export function browserCompat(): BrowserCompatibility {
//    let ret = { compatibility: false, browser: 'Unknown' };

//    let browser = BrowserDetection();
//    ret.browser = browser;
//    ret.compatibility = (browser == 'Chrome' || browser == 'Firefox' || browser == 'Safari' || browser == 'Opera') || browser == 'Edge';

//    return ret;
//}


//export function BrowserDetection() {
//    let ver = detectIE();

//    //if (navigator.userAgent.search("MSIE") >= 0) {
//    //    return "IE";
//    //}
//    //else

//    if (ver == 0) {
//        if (navigator.userAgent.search("Chrome") >= 0) {
//            return "Chrome";
//        }
//        else if (navigator.userAgent.search("Firefox") >= 0) {
//            return "Firefox";
//        }
//        else if (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0) {
//            return "Safari";
//        }
//        else if (navigator.userAgent.search("Opera") >= 0) {
//            return "Opera";
//        }
//    }
//    else {
//        if (ver <= 11)
//            return "IE";
//        else if (ver >= 12)
//            return "Edge";
//        else 
//            return "Unknown"
//    }
//    return "Unknown";
//}

//function detectIE() {
//    var ua = window.navigator.userAgent;

//    // Test values; Uncomment to check result …

//    // IE 10
//    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

//    // IE 11
//    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

//    // Edge 12 (Spartan)
//    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

//    // Edge 13
//    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

//    var msie = ua.indexOf('MSIE ');
//    if (msie > 0) {
//        // IE 10 or older => return version number
//        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
//    }

//    var trident = ua.indexOf('Trident/');
//    if (trident > 0) {
//        // IE 11 => return version number
//        var rv = ua.indexOf('rv:');
//        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
//    }

//    var edge = ua.indexOf('Edge/');
//    if (edge > 0) {
//        // Edge (IE 12+) => return version number
//        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
//    }

//    // other browser
//    return 0;
//}